import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";
import Login from "./Login";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");
  const [confirmpass, setConfirmPass] = useState("");
  const [circle, setCircle] = useState(0);
  const [login, setLogin] = useState(0);
const history = useHistory();
  // const [condition, setCondition] = useState(false);
  const data = {
    "username" : name,
    "password" : pass,
    "confirmPassword" : confirmpass
  }

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function

  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {
    
    const resCondition = validateInput(formData)
    // console.log(resCondition);
      if(resCondition){
      // const response = await
      setCircle(1);
      const apiData = {
        "username" : formData.username,
        "password" : formData.password,
      }
       axios.post(`${config.endpoint}/auth/register`, apiData)
      .then(response=>{
        // console.log(response.data.success); 
        enqueueSnackbar('Registered successfully',{variant:'success'});
        setCircle(0);
        setLogin(1);
      })
      .catch(er=>{
        // console.log(er.response.data.message);
        enqueueSnackbar(er.response.data.message,{variant:'error'});
        setCircle(0);
      });
    }
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  
  const validateInput = (data) => {
    // const dataObj = {
    //   "username" : name,
    //   "password" : pass,
    // }
    // console.log(" In Validate :: ", data);
    // const returningvalue = (name !== "" && !name.length < 6 && pass !== "" && 
    // !pass.length < 6 && confirmpass === pass) ? true : false;

    // const finalObj = {
    //     "returningvalue" : returningvalue,
    //     "dataObj" : dataObj 
    //   }

    // (data.username === "") ? enqueueSnackbar("required",{variant:'warning'}) : 
    // (data.username.length < 6) ? enqueueSnackbar("6",{variant:'warning'}) : 
    // (data.password === "") ? enqueueSnackbar("required",{variant:'warning'}) :
    // (data.password.length < 6) ? enqueueSnackbar("6",{variant:'warning'}) :
    // (data.confirmPassword !== data.password) ? enqueueSnackbar("do not match",{variant:'warning'}) : setCondition(true)

    if(data.username === ""){
      enqueueSnackbar("Username is a required field",{variant:'warning'})
      return false;
    }
    if(data.username.length < 6){
      enqueueSnackbar("Username must be at least 6 characters",{variant:'warning'})
      return false;
    }
    if(data.password === ""){
      enqueueSnackbar("Password is a required field",{variant:'warning'})
      return false;
    }
    if(data.password.length < 6){
      enqueueSnackbar("Password must be at least 6 characters",{variant:'warning'})
      return false;
    }
    if(data.confirmPassword !== data.password){
      enqueueSnackbar("Passwords do not match",{variant:'warning'})
      return false;
    }
    
    return true;

    // if(name === "" || name.length < 6)
    //   enqueueSnackbar("Username must be atleast 6 characters");
    // else if( name.length > 6 && (pass === "" || pass.length < 6))
    //   enqueueSnackbar("Password must be atleast 6 characters");
    // else if(name.length > 6 && confirmpass !== pass)
    //   enqueueSnackbar("Passwords do not match");
    // else
    //   return dataObj;
  };

  return (
    <Box>
  {(login !== 1) ? (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={false} searchBar={false}/>
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            value={name}
            onChange={(e)=>{
              setName(e.target.value)
            }}
            required
            placeholder="Enter Username"
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            value={pass}
            onChange={(e)=>{
              setPass(e.target.value)
            }}
            required
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={confirmpass}
            onChange={(e)=>{
              setConfirmPass(e.target.value)
            }}
            fullWidth
          />
           {circle === 0 && <Button variant="contained" onClick={()=>{register(data)}}>
            Register Now
           </Button>}

           {circle === 1 && <CircularProgress className="circle"/>}
          <p className="secondary-action">
            Already have an account?{" "}
             {/* <a className="link" href="#">
              Login here
             </a> */}
             <Link to="/login" className="link">Login here</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
    ): 
    // (<Login />)
    (history.push('/login'))
    }
    </Box>
  );
};

export default Register;
